<template>
  <b-modal
    v-model="modal"
    :hide-footer="true"
    :no-enforce-focus="true"
    :no-close-on-backdrop="true"
    id="full-screen-modal"
  >
  <template #modal-header="{ close }">
    <div class="flex w-full">
      <div class="flex-1 font-semibold text-xl text-gray-800">
          <div class="flex items-center">
            <div class="shrink-0 mr-4">
              <svg version="1.1" viewBox="0 0 24 24" class="w-5 h-5 svg-icon"><desc>pencil write</desc><g stroke-linecap="round" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linejoin="round"><path pid="0" d="M22.19 1.81h0a3.636 3.636 0 00-5.15.01c-.01 0-.02.01-.03.02l-14.5 14.5-1.78 6.9 6.9-1.78 14.5-14.5h-.01a3.655 3.655 0 00.06-5.15l-.03-.03zM16.61 2.26l5.13 5.13M2.52 16.34l5.14 5.13"></path></g></svg>
            </div>
            <span v-if="!openInput" v-b-tooltip.hover :title="`Click para editar o nome de ${seat.title}`" class="border-b border-gray-500 p-2 truncate link" @click="editTitle()">
              {{ seat.title }}
            </span>
            <div class="form-field-wrapper" v-if="openInput">
              <input
                id="name"
                v-model="seat.title"
                name="name"
                type="text"
                class="form-control"
                v-on:keyup.enter="updateTitle"
              />
            </div>
          </div>
      </div>
      <div class="flex-1 font-semibold text-xl text-gray-800">
        <div class="flex items-center justify-end mr-4 flex-1 hidden text-sm">
          <div class="flex items-center justify-center p-2 rounded text-teal bg-teal-light">
            <svg class="h-6 w-6 svg-icon" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><desc>seating chair</desc><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M1.5 4.88L3 13.12M1.5 19.125l1.5-6h3-.01c.82-.01 1.5.67 1.5 1.5v4.5M22.5 4.88L21 13.12M22.5 19.125l-1.5-6h-3.01c-.83 0-1.5.67-1.5 1.5 0 0 0 0 0 0v4.5M12 8.62v10.5M6.75 8.62h10.5" pid="0"/></g></svg>
          </div>
          <div class="flex flex-col ml-4 text-sm">
            <p class="font-semibold m-0">{{ correctStats.seatingAreas }}</p>
            <p class="m-0">Mesas</p>
          </div>
          <div class="flex items-center justify-center p-2 ml-8 rounded text-green bg-green-light">
            <svg class="h-6 w-6 svg-icon" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M10.782 10.516h0a6.025 6.025 0 00-4.04-1.52h0a5.987 5.987 0 00-6 5.24M6.75.75a3.375 3.375 0 100 6.75 3.375 3.375 0 100-6.75zM16.5.75a2.625 2.625 0 100 5.25 2.625 2.625 0 100-5.25zM20.4 9h0c-1.25-2.16-4-2.89-6.15-1.65-.43.24-.82.56-1.14.93M17.25 11.24a6 6 0 100 12 6 6 0 100-12z" pid="0"/><path d="M19.924 15.5l-2.91 3.87h-.01a.76.76 0 01-1.06.14c-.03-.03-.06-.05-.08-.07l-1.5-1.5" pid="1"/></g></svg>
          </div>
          <div class="flex flex-col ml-4 text-sm">
            <p class="font-semibold m-0">{{ correctStats.occupiedSeats }} de {{ correctStats.totalSeats }}</p>
            <p class="m-0">Sentado(a)</p>
          </div>
        </div>
      </div>
      <div class="grow-0">
        <b-button size="sm" variant="outline-dark" @click="close()">X</b-button>
      </div>
    </div>
  </template>
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :cancel-disabled="false"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="seat-content">
      <!-- HEADER ÚNICO FIXO DIVIDIDO -->
      <div class="unified-header" style="background: #fff; padding: 1rem 1rem 0.5rem 1rem; border-bottom: 1px solid #e9ecef; display: flex; gap: 1rem;">
        <!-- Coluna 1: Área dos Participantes COM FILTRO -->
        <div class="chat-leftsidebar mr-lg-4" style="flex-shrink: 0;">
          <div style="display: flex; gap: 0.5rem; flex-direction: column;">
            <div style="display: flex; gap: 0.5rem;">
              <div class="position-relative" style="flex: 1;">
                <input
                  type="text"
                  class="form-control"
                  v-model="searchParticipant"
                  placeholder="Pesquisar participantes..."
                />
                <i class="bx bx-search-alt search-icon"></i>
              </div>
              <button
                class="btn btn-sm"
                :class="hasActiveFilters ? 'btn-primary' : 'btn-outline-primary'"
                @click="showFilters = !showFilters"
              >
                <i class="bx bx-filter-alt"></i>
              </button>
            </div>

            <div v-if="showFilters" style="border: 1px solid #e9ecef; border-radius: 4px; padding: 0.75rem; background: #f8f9fa;">
              <div class="mb-2">
                <label class="font-weight-bold mb-2" style="font-size: 0.875rem;">Grupos</label>
                <div style="max-height: 150px; overflow-y: auto;">
                  <div v-for="group in groups" :key="group.id" class="form-check mb-1">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      :id="`group-${group.id}`"
                      :value="group.id"
                      v-model="selectedGroups"
                    />
                    <label class="form-check-label" :for="`group-${group.id}`" style="font-size: 0.875rem;">
                      {{ group.name }}
                    </label>
                  </div>
                  <div v-if="!groups || groups.length === 0" class="text-muted text-center" style="font-size: 0.875rem;">
                    Nenhum grupo disponível
                  </div>
                </div>
              </div>
              <div class="text-right">
                <button class="btn btn-sm btn-secondary" @click="selectedGroups = []; showFilters = false">
                  Limpar
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Coluna 2: Área das Mesas -->
        <div style="flex: 1; display: flex; gap: 1rem; align-items: center;">
          <div style="flex: 1;">
            <div class="position-relative">
              <input
                type="text"
                class="form-control"
                placeholder="Pesquisar por mesas..."
              />
              <i class="bx bx-search-alt search-icon"></i>
            </div>
          </div>

          <div class="d-flex" style="gap: 0.5rem;">
            <button class="btn btn-sm btn-outline-dark">
              <i class="mdi mdi-arrow-expand"></i> Expandir
            </button>
            <button class="btn btn-sm btn-success" @click="createNewTable">
              <i class="bx bx-plus-circle"></i> Nova Mesa
            </button>
          </div>
        </div>
      </div>

      <!-- CONTEÚDO COM SCROLL -->
      <div class="d-lg-flex" style="height: calc(100vh - 180px);">
        <div class="chat-leftsidebar mr-lg-4" style="position: sticky; top: 0; height: 100%; overflow-y: auto;">
          <div class="">
            <h4 class="card-title mb-4" style="margin-top: 1.5rem;">Participantes</h4>
            <div class="chat-leftsidebar-nav">
              <div class="tab-content py-4">
                  <div class="select-none">
                    <div class="mb-2">
                      <div>
                        <draggable
                          v-if="availableParticipants && availableParticipants.length"
                          :list="availableParticipants"
                          :group="{ name: 'participants', pull: 'clone', put: false }"
                          :clone="cloneParticipant"
                          :sort="false"
                          @start="onDragStart"
                          @end="onDragEnd"
                          class="bg-white"
                        >
                          <div
                            v-for="p in availableParticipants"
                            :key="p.id"
                            :data-participant-id="p.id"
                            class="flex items-center space-x-3 p-3 border-b border-gray-100 cursor-move hover:bg-gray-50"
                          >
                            <div class="w-full">
                              <i class="mdi mdi-drag-vertical mr-2 text-muted"></i>
                              <strong>{{ p.name }}</strong>
                              <br>
                              <small class="text-muted">{{ p.email }}</small>
                            </div>
                          </div>
                        </draggable>
                        <div v-else class="text-center p-4 text-muted">
                          <p>Nenhum participante disponível</p>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 user-chat" style="flex: 1; display: flex; flex-direction: column; height: 100%;">
          <div style="flex: 1; overflow-y: auto; padding: 1rem;">
          <div class="drag-container" v-if="seat.areas && seat.areas.data">
            <div class="row drag-list">
              <div class="col-lg-4 col-md-12 col-sm-12 drag-column" v-for="table in seat.areas.data" :key="table.id">
                <div class="table-card mt-2">
                  <div class="table-header">
                    <b-card-header header-tag="header" class="table-header-card" role="tab">
                      <h6 class="m-0">
                        <div class="btn-group">
                          <b-dropdown variant="white">
                            <template v-slot:button-content>
                              <i class="bx bx-dots-vertical"></i>
                            </template>
                            <b-dropdown-item class="table-actions">
                              <i class="bx bxs-edit"></i>
                              Editar Mesa
                            </b-dropdown-item>
                            <b-dropdown-item class="table-actions delete">
                              <i class="bx bxs-trash"></i>
                              Deletar Mesa
                            </b-dropdown-item>
                          </b-dropdown>
                        </div>
                        {{ table.name }}
                        <a
                          v-b-toggle="'accordion-' + table.id"
                          class="text-dark float-right m-2"
                          href="javascript: void(0);"
                        >
                        <span class="when-opened">
                          <i class="fas fa-angle-down"></i>
                        </span>
                        <span class="when-closed">
                          <i class="fas fa-angle-up"></i>
                        </span>
                        </a>
                      </h6>
                    </b-card-header>
                    <b-collapse :id="`accordion-${table.id}`" visible :accordion="`table-${table.id}`" role="tabpanel">
                      <draggable
                        :list="[]"
                        :group="{ name: 'participants', put: true, pull: false }"
                        @add="onSeatAdd($event, table.id)"
                        class="seat-dropzone"
                      >
                        <div
                          v-for="(seat, idx) in table.number_of_seats"
                          :key="idx"
                          class="seat-participant py-2 pl-2 select-none"
                          :class="{ 'seat-occupied': getSeatData(table.id, idx + 1) && getSeatData(table.id, idx + 1).seatable }"
                        >
                          <div class="d-flex align-items-center justify-content-between">
                            <div class="flex-grow-1">
                              <span class="seat-number">{{ idx + 1 }}.</span>
                              <template v-if="getSeatData(table.id, idx + 1) && getSeatData(table.id, idx + 1).seatable">
                                <span class="ml-2">
                                  <strong>{{ getSeatData(table.id, idx + 1).seatable.data.name }}</strong>
                                </span>
                              </template>
                              <span v-else class="text-muted ml-2">Assento vazio</span>
                            </div>
                            <button
                              v-if="getSeatData(table.id, idx + 1) && getSeatData(table.id, idx + 1).seatable"
                              class="btn btn-sm btn-outline-danger"
                              @click="unseatParticipant(table.id, getSeatData(table.id, idx + 1))"
                            >
                              <i class="bx bx-x"></i>
                            </button>
                          </div>
                        </div>
                      </draggable>
                    </b-collapse>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="text-center p-5 text-muted">
            <p>Carregando mesas...</p>
          </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import draggable from 'vuedraggable'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions, mapState } from 'vuex'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import * as services from './services'
import Swal from 'sweetalert2'

export default {
  components: {
    draggable,
    Loading
  },
  props: {
    idseating: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      title: 'Novo Seating - Ambiente',
      loading: true,
      newTitle: null,
      openInput: false,
      fullPage: true,
      submitted: false,
      seat: {},
      modal: false,
      draggingParticipant: null,
      showFilters: false,
      searchParticipant: '',
      selectedGroups: []
    }
  },
  methods: {
    ...mapActions('settings', { GetStatus: 'GetStatusSelect' }),
    ...mapActions('seating', {
      getShow: 'show',
      saveSeat: 'save',
      getParticipants: 'getAllAParticipants'
    }),
    ...mapActions('tag', {
      getAll: 'getAll'
    }),
    ...mapActions('group', {
      getAllGroups: 'getAll'
    }),

    cloneParticipant (participant) {
      return { ...participant }
    },

    onDragStart (evt) {
      if (!evt || !evt.item || !evt.item.dataset) return
      const participantId = evt.item.dataset.participantId
      if (!participantId || !this.participantsSeat) return
      this.draggingParticipant = this.participantsSeat.find(p => p && p.id === parseInt(participantId))
    },

    onDragEnd () {
      this.draggingParticipant = null
    },

    async onSeatAdd (evt, areaId) {
      const seatPosition = evt.newIndex + 1
      const participant = this.draggingParticipant

      if (!participant) {
        errorMessage('Erro ao identificar participante')
        evt.item.remove()
        return
      }

      const existingSeat = this.getSeatData(areaId, seatPosition)

      if (existingSeat && existingSeat.seatable) {
        errorMessage('Atenção! Este assento já está ocupado.')
        evt.item.remove()
        return
      }

      this.loading = true

      try {
        await services.seatParticipant(this.seat.id, areaId, {
          participant_id: participant.id,
          seat_position: seatPosition
        })

        successMessage('Participante alocado com sucesso!')
        await this.loadItem(this.seat.id)
        await this.getParticipants({ id: this.seat.id, limit: 1000 })
      } catch (error) {
        console.error('Erro ao alocar:', error)
        errorMessage(error.response?.data?.message || 'Erro ao alocar participante')
        evt.item.remove()
      } finally {
        this.loading = false
      }
    },

    async unseatParticipant (areaId, seatData) {
      const result = await Swal.fire({
        title: 'Confirmar',
        text: 'Deseja remover este participante do assento?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Sim, remover',
        cancelButtonText: 'Cancelar'
      })

      if (!result.isConfirmed) return

      this.loading = true

      try {
        await services.unseatParticipant(this.seat.id, areaId, {
          participant_id: seatData.seatable_id
        })

        successMessage('Participante removido com sucesso!')
        this.loadItem(this.seat.id)
        await this.getParticipants({ id: this.seat.id, limit: 1000 })
      } catch (error) {
        errorMessage(error.response?.data?.message || 'Erro ao remover participante')
      } finally {
        this.loading = false
      }
    },

    getSeatData (areaId, seatPosition) {
      if (!this.seat || !this.seat.areas || !this.seat.areas.data) {
        return null
      }
      const area = this.seat.areas.data.find(a => a && a.id === areaId)
      if (!area) {
        return null
      }

      if (!area.seats || !area.seats.data) {
        return null
      }

      const seatData = area.seats.data.find(s => s && s.seat_position === seatPosition)

      if (seatData && seatData.seatable_id) {
        return seatData
      }

      return null
    },

    editTitle () {
      this.openInput = !this.openInput
    },
    async updateTitle () {
      this.openInput = !this.openInput
      if (!this.seat.title) {
        errorMessage('Nome do ambiente é obrigatório')
      }
      this.loading = true
      await this.saveSeat({ id: this.seat.id, title: this.seat.title }).then(() => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.loading = false
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    setFilterseating () {
      this.seating.groups = []
      this.seating.status = []
      this.seating.tags = []
    },
    getListParticipants () {
      let params = {
        limit: 20,
        page: 1
      }
      this.params = params
      this.getParticipants(this.params).then(() => {
      }).catch(error => {
        console.log(error)
      })
    },
    getTags () {
      let params = {
        limit: 100,
        page: 1
      }
      this.params = params
      this.getAll(this.params).then(() => {
      }).catch(error => {
        console.log(error)
      })
    },
    getGroups () {
      let params = {
        status: 1,
        limit: 100,
        page: 1
      }
      this.params = params
      this.getAllGroups(this.params).then(() => {
      }).catch(error => {
        console.log(error)
      })
    },
    loadItem (id) {
      if (id) {
        this.loading = true
        this.getShow(id).then((response) => {
          if (this.data && this.data.id) {
            if (this.data.areas && !this.data.areas.data) {
              this.seat = {
                ...this.data,
                areas: { data: this.data.areas || [] }
              }
            } else {
              this.seat = this.data
            }
          } else {
            this.seat = { areas: { data: [] } }
          }
        }).catch((error) => {
          console.error('Erro ao carregar:', error)
          this.seat = { areas: { data: [] } }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    open (id) {
      this.getTags()
      this.getGroups()
      this.GetStatus()
      this.getListParticipants()
      this.loading = true
      this.modal = true
      if (id) {
        this.loadItem(id)
      } else {
        this.loading = false
      }
    },
    async saveSeating () {
      this.submitted = true
      this.$v.seating.$touch()
      if (this.$v.seating.$invalid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true
      await this.postData(this.seating).then(() => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.seat = {}
      this.$emit('created')
    },

    async createNewTable () {
      // Pegar configuração da primeira mesa existente
      if (!this.seat?.areas?.data || this.seat.areas.data.length === 0) {
        errorMessage('Nenhuma mesa base encontrada')
        return
      }

      const firstArea = this.seat.areas.data[0]
      const numberOfSeats = firstArea.number_of_seats

      // Contar quantas mesas já existem para gerar o nome
      const totalAreas = this.seat.areas.data.length
      const newName = `Mesa ${totalAreas + 1}`

      this.loading = true

      try {
        await services.createArea(this.seat.id, {
          name: newName,
          number_of_seats: numberOfSeats
        })

        successMessage(`Mesa criada: ${newName} (${numberOfSeats} assentos)`)

        await this.loadItem(this.seat.id)
      } catch (error) {
        console.error('Erro ao criar mesa:', error)
        errorMessage(error.response?.data?.message || 'Erro ao criar mesa')
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    ...mapState('settings', ['statusSelect']),
    ...mapState('seating', { data: 'seat' }),
    ...mapState('seating', ['participantsSeat', 'paginationP']),
    ...mapState('tag', ['tags']),
    ...mapState('group', ['groups']),

    correctStats () {
      let totalSeats = 0
      let occupiedSeats = 0
      let seatingAreas = 0

      if (this.seat?.areas?.data) {
        seatingAreas = this.seat.areas.data.length

        this.seat.areas.data.forEach(area => {
          totalSeats += area.number_of_seats || 0

          if (area.seats?.data) {
            area.seats.data.forEach(seat => {
              if (seat.seatable_id || seat.seatable?.data?.id) {
                occupiedSeats++
              }
            })
          }
        })
      }

      return { seatingAreas, totalSeats, occupiedSeats }
    },

    availableParticipants () {
      if (!this.participantsSeat || !Array.isArray(this.participantsSeat)) {
        return []
      }

      const allocatedIds = new Set()
      if (this.seat?.areas?.data) {
        this.seat.areas.data.forEach(area => {
          if (area?.seats?.data) {
            area.seats.data.forEach(seat => {
              if (seat?.seatable?.data?.id) {
                allocatedIds.add(seat.seatable.data.id)
              }
            })
          }
        })
      }

      let filtered = this.participantsSeat.filter(p => !allocatedIds.has(p.id))

      if (this.searchParticipant && this.searchParticipant.trim()) {
        const search = this.searchParticipant.toLowerCase()
        filtered = filtered.filter(p =>
          p.name?.toLowerCase().includes(search) ||
          p.email?.toLowerCase().includes(search)
        )
      }

      if (this.selectedGroups.length > 0) {
        filtered = filtered.filter(p => {
          if (!p.groups || !Array.isArray(p.groups)) return false
          return p.groups.some(g => this.selectedGroups.includes(g.id))
        })
      }

      return filtered
    },

    hasActiveFilters () {
      return this.selectedGroups.length > 0
    }
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    },
    data: {
      handler (newVal) {
        if (newVal && newVal.id && this.modal) {
          if (newVal.areas && !newVal.areas.data) {
            this.seat = {
              ...newVal,
              areas: { data: newVal.areas || [] }
            }
          } else {
            this.seat = newVal
          }
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
.collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }
::v-deep .dropdown-menu {
  padding: 0 !important;
}
::v-deep .table-actions > .dropdown-item {
  padding: 0.55rem 0.75rem;
}
::v-deep .delete > .dropdown-item:hover, .dropdown-item:focus {
    color: rgb(221, 7, 7);
  }
.table-header-card {
    padding: 0.75rem 0.25rem;
    margin-bottom: 0;
    background-color: #fff;
    border: 2px solid #f0f0f0;
}
::v-deep .btn-group > .btn-white {
  padding: 0.30rem 0.25rem !important;
}
.seat-participant {
  background: #fff;
}
.seat-participant:hover {
  background: #f7f7f7;
  cursor: move;
}
.seat-content {
  background: #fff;
  height: 100%;
  padding: 1rem;
}
    ::v-deep #full-screen-modal > .modal-dialog {
      max-width: 100%;
      height: 100%;
      bottom: 0;
      margin: 0;
    }
    ::v-deep #full-screen-modal > .modal-dialog > .modal-content {
      height: 100%;
      border-radius: 0;
      display: flex;
      flex-direction: column;
    }
    ::v-deep #full-screen-modal > .modal-dialog > .modal-content > .modal-body {
      flex: 1;
      overflow: hidden;
      padding: 0;
    }
    ::v-deep #full-screen-modal > .modal-dialog > .modal-content > .modal-header {
      background: #f7f7f7;
    }
   ::v-deep #full-screen-modal > .modal-dialog > .modal-content > .modal-header > .close {
      font-size:  2.21875rem;
      font-weight: normal;
    }

.seat-occupied {
  background: #e3f2fd;
}

.seat-dropzone {
  min-height: 50px;
}

.seat-number {
  font-weight: 600;
  color: #495057;
}

.drag-list {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.drag-list > [class*='col-'] {
  padding-left: 0 !important;
  padding-right: 15px !important;
}

.unified-header .search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #6c757d;
}

.unified-header .position-relative {
  position: relative;
}
</style>
